import React from 'react';
import { ViewModel } from '../../controller/viewModel/viewModel';

export const WidgetViewModelContext = React.createContext<ViewModel>(
  {} as ViewModel,
);

export const WidgetViewModelConsumer = WidgetViewModelContext.Consumer;
export const WidgetViewModelProvider = WidgetViewModelContext.Provider;

export const useWidgetViewModel = () =>
  React.useContext(WidgetViewModelContext);
